import React, { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';


const Dashboard = () => {
  // State to track the total tasks and the total days completed
  const [totalTasks, setTotalTasks] = useState(0);
  const [averageDaysCompleted, setAverageDays] = useState(0);

  // The target number of tasks to reach
  const targetTasks = 2000;

  // Effect to calculate total tasks, total days, and number of users
  useEffect(() => {

    axiosInstance.get('/users/dashboard').then(response => {
        const data = response.data;
        setTotalTasks(data.total_tasks_completed_all_users);
        setAverageDays(data.average_days_completed_for_user)
    })
  }, []);

  // Calculate the average number of days completed
 
  const progressPercent = (totalTasks / targetTasks) * 100;

  return (
    <div className="dashboard-container" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', backgroundColor: 'white', borderRadius: '8px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* Average Days Completed */}
        <div style={{ padding: '15px', borderRadius: '8px', border: '1px solid #ddd', backgroundColor: 'white' }}>
          <h5 style={{ color: 'black' }}>Your Average Days Completed</h5>
          <p style={{ color: 'gray' }}>This is your average number of tasks completed per 21-day challenge. 
            A task is an activity performed on a single day during the duration of a challenge.
          </p>
          <p style={{ fontWeight: 'bold' }}><span style={{ color: '#FF6F61', fontWeight: 'bold' }}>{averageDaysCompleted} </span> days</p>
        </div>

        {/* Total Tasks Completed */}
        <div style={{ padding: '15px', borderRadius: '8px', border: '1px solid #ddd', backgroundColor: 'white' }}>
          <h5 style={{ color: 'black' }}>Community Total Tasks Completed</h5>
          <p style={{ color: 'gray' }}>This metric shows the total number of tasks completed by everyone in the community while working toward our shared goal.</p>
          <p style={{ fontWeight: 'bold' }}><span style={{ color: '#FF6F61', fontWeight: 'bold' }}>{totalTasks} </span> / {targetTasks} tasks</p>
          <div style={{ height: '10px', backgroundColor: '#EDEDED', borderRadius: '5px', marginTop: '5px' }}>
            <div
              style={{
                width: `${progressPercent}%`,
                height: '100%',
                backgroundColor: progressPercent >= 100 ? 'green' : '#4f8acf', // Light green when less than 100%
                borderRadius: '5px',
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

